/*
Defines the custom element <ravel-physics-world>
*/

import { RavelPhysicsWorld } from './src/RavelPhysicsWorld.js';

customElements.define('ravel-physics-world', RavelPhysicsWorld);

